export default {
  meta: {
    'key-content': '免费语音通话, 安全通信, 即时通信, 阅后即焚, 安全聊天, 加密聊天, Telegram, Sugram, Whatsapp',
    'description-content': 'Crait是一款安全通信和协作工具，旨在提升个人和组织的沟通效率的同时保护数据和信息安全。通过企业级的数据加密，用户的隐私将会得到有效保护。',
    'h-m-title': 'Crait | 聊任何你想聊的'
  },
  head: {
    'home': '首页',
    'features': '产品',
    'pricing': '定价',
    'resources': '资源',
    'openapi': '开放平台',
    'contact': '联系我们',
    'download': '下载',
    'login': '登录'
  },
  home: {
    'title1': '聊任何你想聊的',
    'title2': '安全即时通信',
    'subtitle': '端到端加密 · 阅后即焚 · 免费音视频电话',
    'placeholder': '您的邮箱，电话或用户名',
    'getstart': '即刻试用',
    'contitle': 'Crait的优势',
    'intro1-title': '为团队协同设计',
    'intro1-detail': '支持创建1000人群组，群组内发送消息、图片和视频均经过端到端加密保护',
    'intro2-title': '为安全通讯设计',
    'intro2-detail': '行业标准的256位AES端到端加密技术，所有通讯均有传输层保护（TLS），有效防止中间人攻击',
    'intro3-title': '为高度可定制化设计',
    'intro3-detail': '组织管理者可以在Crait中创建组织架构，同时通过权限控制，来自定义组织中的数据访问权限',
    'keyfeature-title': '核心功能',
    'keyfeature-list1': '安全聊天',
    'keyfeature-list2': '安全语音',
    'keyfeature-list3': '安全文件传输',
    'keyfeature-list4': '支持多平台',
    'keyfeature-list5': '语音消息',
    'keyfeature-list6': '安全云盘',
    'learnmore': '了解更多',
    'download-title': '支持各大平台',
    'download-detail': 'Crait是一款为安全团队沟通和协作而设计的加密通信软件，支持跨平台间同步用户数据，旨在提升工作效率和安全性'
    // 'praise': '客户评价',
    // 'praise-part1-detail': '安全传输文件一直是我们工作中的一个痛点，在使用Crait作为我们的通信平台之后，当需要传输包含敏感客户信息的文件时，我们感到更加安全和放心了。',
    // 'praise-part1-username': 'Thomas Robb,',
    // 'praise-part1-job': 'CTO, Hithink Financial Services',
    // 'praise-part2-detail': 'Crait对于我们的内部沟通来说非常重要，它可以帮助我们省去打电话和发送邮件的时间。',
    // 'praise-part2-username': 'Sherry Shi,',
    // 'praise-part2-job': 'CEO, MoreBack TAX & Accounting'
  },
  features: {
    'f-title': '高度集成团队协作功能的同时，用端到端加密技术来保护用户的信息安全',
    'feature-title': '安全团队沟通',
    'feature-list1-title': '安全聊天',
    'feature-list1-detail': '支持点对点聊天和最大1000人的群聊',
    'feature-list2-title': '安全语音',
    'feature-list2-detail': '支持点对点语音呼叫和最多10人的电话会议',
    'feature-list3-title': '电话会议',
    'feature-list3-detail': '支持端到端加密的电话会议，自带“语音聚焦”功能，自动增加发言人音量的同时过滤环境噪音',
    'feature-list4-title': '跨平台同步',
    'feature-list4-detail': '支持各大主流平台',
    'feature-list5-title': '语音消息',
    'feature-list5-detail': '支持发送语音消息',
    'feature-list6-title': '安全文件分享',
    'feature-list6-detail': '支持在群组中安全分享最大100MB的文件',
    'feature-list7-title': '安全云盘',
    'feature-list7-detail': '支持最大1GB的加密个人云盘',
    'feature-list8-title': '群发消息',
    'feature-list8-detail': '支持向个人好友或组织成员群发消息',
    'feature-list9-title': '安全性',
    'feature-list9-detail': '集成阅后即焚、消息防截屏、消息阅读回执功能',
    'other-feature': '其他功能',
    'other-list1-title': '可定制插件',
    'other-list1-detail': '客户可根据行业或组织的特定需求定制插件，例如日历分享、会议室预定、办公室物资管理等',
    'other-list2-title': '搜索',
    'other-list2-detail': '支持跨聊天搜索历史消息、组织内跨部门搜索成员'
  },
  pricing: {
    'p-title1': '功能',
    'p-title2': 'Crait',
    'p-title3': 'Crait Pro',
    'unlimited': '无限',
    'tr1-td1': '群组数量限制',
    'tr2-td1': '群成员人数限制',
    'tr3-td1': '广播消息人数限制',
    'tr4-td1': '电话会议人数限制',
    'tr5-td1': '群空间容量',
    'tr6-td1': '个人云盘容量',
    'tr7-td1': '视频电话',
    'tr8-td1': '定制插件',
    'tr8-td2': '不支持',
    'tr8-td3': '按单个插件计费',
    'tr9-td1': '客户服务和技术支持',
    'tr9-td2': 'APP内技术支持',
    'tr9-td3': '7x24小时 (邮件或电话)',
    'tr10-td1': '提供团队管理平台',
    'tr11-td1': '全平台支持',
    'tr12-td1': '价格',
    'tr12-td2': '免费',
    'tr12-td3': '2.99美元每月',
    'btn1': '即刻试用',
    'btn2': '现在升级'
  },
  resources: {
    'readmore1': '阅读更多 ->',
    'readmore2': '阅读更多',
    'r-title1': '白皮书',
    'r-title2': '博客',
    'subtitle1': 'WHAT IS CRAIT?',
    'detail1': 'Crait is where secure communication and collaboration happens. It is a secure messaging tool designed to make working life easier and more productive for work-groups...',
    'subtitle2': 'Data Breach Trends',
    'detail2': 'Data breaches are no good. It will serve companies well to reexamine their basic security hygiene with a deliberate view of strengthening their respective security postures...',
    'subtitle3': 'Small Enterprises Are Easy Targets',
    'detail3': 'Not all commonsensical ideas hold water. One example of a commonplace idea that does not match reality is the notion that hackers only target big businesses. The rising number of cyber attacks on small businesses strongly contradicts this seemingly prevalent sentiment that small businesses aren’t the target of hacks. Let’s examine the facts...'
  },
  contact: {
    'c-title1': '欢迎您与我们进一步沟通了解更多关于Crait的信息',
    'c-title2': '请提供更多关于您组织的信息，我们的销售人员会很快与您取得联系',
    'firstname': '姓氏 *',
    'lastname': '名字 *',
    'workemail': '工作邮箱 *',
    'phone': '电话号码 *',
    'company': '组织名称 *',
    'size': '组织规模 *',
    'location': '地点',
    'industry': '行业',
    'send': '发送',
    // 'address': '地址: 5005 Newport Drive, Suite 510 Rolling Meadows, IL',
    // 'zipcode': '邮编: 60008',
    // 'tel': '电话号码: +1 (847)873-1567',
    'emaillabel': '邮箱: ',
    'email': 'info@craitcorp.com'
  },
  download: {
    'intro': 'Crait是一款为安全团队沟通和协作而设计的加密通信软件，支持跨平台间同步用户数据，旨在提升工作效率和安全性',
    'd-title': '应用支持各大平台',
    'sub-intro1': '您可以扫码或者点击下方按钮下载Crait.',
    'sub-intro2': '或者即刻开始使用Crait Web版'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/cn.js